export const paidMarketingPlanSizes = [100, 250, 500, 750, 1000, 1250]
export const botMitigationPlanSizes = [200, 400, 700, 1000, 1500, 1750]
